import { Home, AppStoreRedirect } from './pages';
import { Routes, Route, Outlet } from 'react-router-dom';

const App = ()=>{
  return (
    <div>
      <Routes>
        <Route path="/" element={<Layout/>}>
          <Route index element={<Home/>}/>
          <Route path="friend" element={<AppStoreRedirect/>}/>
          <Route path="*" element={<Home/>} />
        </Route> 
      </Routes>
    </div>
  );
}

const Layout = ()=>{
  return (
    <div className="page">      
      <div className="content">
        <Outlet/>
      </div>
      
    </div>
  );
}

export default App;
